import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-pagination-summary',
  templateUrl: './pagination-summary.component.html',
  styleUrls: ['./pagination-summary.component.css']
})
export class PaginationSummaryComponent implements OnChanges {
  firstItem: number;
  lastItem: number;

  @Input() page: number;
  @Input() itemsPerPage: number;
  @Input() itemCount: number;

  ngOnChanges() {
    this.calculate();
  }

  calculate() {
    this.firstItem = ((this.page - 1) * this.itemsPerPage) + 1;
    this.lastItem = Math.min(this.page * this.itemsPerPage, this.itemCount);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/components/managers/pagination-summary/pagination-summary.component.ts